<template>
  <v-list>
    <div v-for="item in filterTabData" :key="item.id">
      <span v-if="item">
        <v-subheader class="subtitle-2 primary--text">
          {{ item.subheader }}
        </v-subheader>

        <template v-if="!item.properties.chips">
          <v-hover
            v-slot:default="{ hover }"
            v-for="itemInner in filterDrops(item.properties)"
            :key="itemInner.id"
          >
            <div>
              <v-list-item
                :data-test-item-prop="itemInner.title"
                @click="clickHandler(itemInner, item)"
                v-if="itemInner.type !== 'additionalItem' && !itemInner.hidden"
              >
                <template>
                  <v-list-item-icon v-if="itemInner.icon !== 'none'">
                    <v-icon v-if="itemInner.icon && itemInner.icon.name">
                      {{ itemInner.icon.name }}
                    </v-icon>
                  </v-list-item-icon>

                  <v-list-item-content>
                    <v-list-item-title v-if="itemInner.title">
                      <pre
                        v-if="item.subheader.toLowerCase() === 'schema'"
                        v-html="itemInner.title"
                      ></pre>
                      <span
                        :class="{
                          'text-wrap':
                            item.subheader.toLowerCase() === 'description' ||
                            item.subheader.toLowerCase() === 'message'
                        }"
                        v-else-if="
                          item.subheader.toLowerCase() === 'description' ||
                            item.subheader.toLowerCase() === 'message'
                        "
                      >
                        {{ itemInner.title }}</span
                      >
                      <div
                        style="max-width: 320px; display: inline-block;"
                        class="text-truncate"
                        v-else
                      >
                        {{ itemInner.title }}
                      </div>
                    </v-list-item-title>
                    <v-list-item-subtitle
                      style="max-width: 285px; display: inline-block; top: 0;"
                    >
                      {{ itemInner.subtitle }}

                      <v-tooltip
                        top
                        v-if="
                          itemInner.linkedPropertyId &&
                            itemInner.linkedPropertyId.value
                        "
                      >
                        <template v-slot:activator="{ on }">
                          <v-btn
                            small
                            icon
                            v-on="on"
                            @click.stop="
                              redirectTo(
                                itemInner.linkedPropertyId.value.object.schema
                                  .type,
                                itemInner.linkedPropertyId.value.object.id
                              )
                            "
                          >
                            <v-icon small>mdi-link-variant</v-icon>
                          </v-btn>
                        </template>
                        <span
                          >{{ itemInner.linkedPropertyId.value.object.name }}:
                          {{ itemInner.linkedPropertyId.value.groupName }}/{{
                            itemInner.linkedPropertyId.value.property
                          }}
                        </span>
                      </v-tooltip>
                    </v-list-item-subtitle>
                    <v-list-item-subtitle
                      v-if="itemInner.date || itemInner.ownerChange"
                    >
                      {{ itemInner.date }} {{ itemInner.ownerChange }}
                    </v-list-item-subtitle>
                  </v-list-item-content>

                  <v-list-item-action v-if="itemInner.isHoverAction">
                    <dropdown-menu
                      v-if="item.action !== 'copy'"
                      :items="item.contextMenu || itemInner.contextMenu"
                      item-key-text="text"
                      :itemKeyValue="'id'"
                      :hover="hover"
                      @input="handleContext($event, itemInner)"
                    >
                      <template v-slot:activator="{ on }">
                        <slot name="activator" :on="on">
                          <v-btn
                            :data-test-ctx-menu="itemInner.title"
                            slot="activator"
                            v-show="hover || $vuetify.breakpoint.mdAndDown"
                            v-on="on"
                            class="table-button-context"
                            icon
                            color="#686868"
                          >
                            <v-icon>mdi-dots-vertical</v-icon>
                          </v-btn>
                        </slot>
                      </template>
                    </dropdown-menu>
                    <v-btn
                      v-else
                      @click="clickElement(itemInner, item)"
                      slot="activator"
                      v-show="hover || $vuetify.breakpoint.mdAndDown"
                      class="table-button-context"
                      icon
                    >
                      <v-icon>mdi-image-filter-none</v-icon>
                    </v-btn>
                  </v-list-item-action>
                </template>
              </v-list-item>

              <div class="pr-2" v-else-if="itemInner.id === 'reload-app'">
                <v-btn
                  outlined
                  block
                  :disabled="!itemInner.disabled"
                  color="primary"
                  @click="$emit('action', itemInner)"
                >
                  {{ itemInner.title }}
                </v-btn>
              </div>
              <v-list-item v-else @click="$emit('action', itemInner)">
                <v-list-item-icon>
                  <v-icon>{{ itemInner.icon.name }}</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ itemInner.title }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </div>
          </v-hover>
        </template>
        <template v-else>
          <div class="pa-4 pt-0 pb-3">
            <v-chip
              color="primary"
              small
              class="mr-2 mb-2"
              @click="itemChip.link ? $router.push(itemChip.link) : null"
              :key="itemChip.id"
              v-for="itemChip in item.properties.chips"
            >
              {{ itemChip.title }}
            </v-chip>
          </div>
        </template>
      </span>
    </div>
    <template v-for="(itemAdditional, index) in tabData.additionalItems">
      <v-list-item :key="index" @click="$emit('action', itemAdditional)">
        <v-list-item-icon>
          <v-icon>{{ itemAdditional.icon.name }}</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>
            {{ itemAdditional.title }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </template>
  </v-list>
</template>

<script>
import DropdownMenu from '@/components/DropdownMenu';
import copyToClipboard from '@/utils/copyToClipboard';

export default {
  name: 'AppEntityTabProperties',
  components: { DropdownMenu },
  props: {
    tabData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      edited: null,
      fieldValue: '',
      fieldName: ''
    };
  },
  computed: {
    filterTabData() {
      return this.tabData.items.filter(item => item);
    }
  },
  methods: {
    clickElement(el, outerEl) {
      const value = el.title;
      copyToClipboard(value);

      if (typeof value !== 'string') {
        copyToClipboard(JSON.stringify(value, null, '  '));
      } else {
        copyToClipboard(value);
      }

      if (el.handleAction) {
        el.handleAction();
      }
    },
    filterDrops(properties) {
      if (Array.isArray(properties)) return properties.filter(item => item);
      return properties;
    },
    handleContext(action, context) {
      this.$emit('action', { name: action, context: context });
    },
    redirectTo(type, id) {
      switch (type) {
        case 'media':
          this.$router.push({ name: 'mediasTableComponent', params: { id } });
          break;
        case 'dataset':
          this.$router.push({ name: 'datasetsTableComponent', params: { id } });
          break;
        case 'application':
          this.$router.push({ name: 'appsTableComponent', params: { id } });
          break;
        default:
          this.$router.push({ name: 'devicesTableComponent', params: { id } });
      }
    },
    clickHandler(itemInner, item) {
      console.log(itemInner, item);
      const editItem = itemInner.contextMenu?.find(
        item => item.id === 'edit-property'
      );

      if (editItem) {
        editItem.handleAction();
      } else {
        this.clickElement(itemInner, item);
      }
    }
  }
};
</script>
